export const ERROR_GET_ACTIVIIES_LISTE =
	"Une erreur est survenue lors de la mise à jour du statut de l'activité, veuillez réessayer";
export const ERROR_UPDATE_STATUS_ACTIVITY =
	"Une erreur est survenue lors de la mise à jour du statut de l'activité, veuillez réessayer";
export const ERROR_GET_PLANNING =
	'Une erreur est survenue lors de la récupération du planning de la ressource, veuillez réessayer';
export const ERROR_GET_SKILLS =
	'Une erreur est survenue lors de la récupération des compétences, veuillez réessayer';
export const ERROR_GET_SECTEURS =
	'Une erreur est survenue lors de la récupération des secteurs, veuillez réessayer';
export const ERROR_GET_RESOURCES =
	'Une erreur est survenue lors de la récupération des ressources, veuillez réessayer';
export const ERROR_FORMAT_CONTENT_DOCUMENT =
	'Le format ou le type de contenu de(s) fichier(s) est non valide';
export const ERROR_SIZE_DOCUMENT =
	'La taille du fichier dépasse la taille maxi 8 Mo autorisée';
export const ERROR_SIZE_DOCUMENTS =
	'La taille des fichiers dépasse la taille maximum autorisée de 8 Mo';
export const ERROR_UPLOAD_DOCUMENTS =
	"Une erreur s'est produite lors du téléchargement des documents";
export const BIND_API_USER_PASSWORD_ERRORS = [];
BIND_API_USER_PASSWORD_ERRORS['Password must be at least 8 characters long'] =
	"Le mot de passe doit être composé d'au minimum 8 caratères";
BIND_API_USER_PASSWORD_ERRORS[
	'Password must contain at least one uppercase letter'
] = 'Le mot de passe doit comporter au moins 1 lettre majuscule';

BIND_API_USER_PASSWORD_ERRORS['Password must contain at least one number'] =
	'Le mot de passe doit comporter au moins 1 chiffre';
BIND_API_USER_PASSWORD_ERRORS[
	'Password must contain at least one special character'
] = 'Le mot de passe doit comporter au moins 1 caractère spécial';
BIND_API_USER_PASSWORD_ERRORS[
	'Password must contain at least one lowercase letter'
] = 'Le mot de passe doit comporter au moins 1 lettre minuscule';
BIND_API_USER_PASSWORD_ERRORS['Username must be at least 6 characters long'] =
	"Le nom d'utilisateur doit comporter au moins 6 caractères";
BIND_API_USER_PASSWORD_ERRORS[
	'This password has been compromised and cannot be used.'
] = 'Le mot de passe ne peut pas être utilisé.';
BIND_API_USER_PASSWORD_ERRORS['User not found'] = "L'utilisateur n'existe pas";
